import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-workplace-documents',
  templateUrl: './workplace-documents.component.html',
  styleUrls: ['./workplace-documents.component.scss']
})
export class WorkplaceDocumentsComponent implements OnInit {
  @Input() id:string;

  constructor() { }

  ngOnInit() {
  }

}
